module.exports = __webpack_public_path__ + "media/male.52ed60d4.wav";